import React, { useContext } from "react";
import { Link, Route, useHistory } from "react-router-dom";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import { makeStyles } from "@material-ui/core/styles";

import { UIContext } from "../../context/UIContext";
import { SessionContext } from "../../context/SessionContext";

import IntroAccess from "./IntroAccess";
import RequestAccess from "./RequestAccess";
import TrialAccess from "./TrialAccess";

const useStyles = makeStyles({
  card: {
    background: "rgba(18, 20, 30, 0.9)",
    bottom: "0",
    color: "#FFF",
    margin: "2vh 1vw",
    position: "absolute",
    borderRadius: "2px",
    textAlign: "center",
    width: "30vw",
    "@media only screen and (min-width: 425px)": {
      padding: "0 1vw",
      width: "23vw"
    },
    "@media only screen and (min-width: 800px)": {
      width: "20vw"
    },
    "@media only screen and (min-width: 1400px)": {
      width: "16vw"
    },
    "@media only screen and (min-width: 1600px)": {
      width: "14vw"
    }
  },
  cardToggled: {
    bottom: "26vh"
  },
  requestRes: {
    display: "none",
    "@media only screen and (min-width: 600px)": {
      display: "inline"
    }
  },
  requestButton: {
    background: "#228CBD",
    borderRadius: "2px",
    fontSize: "0.7em",
    margin: "0 1vw",
    padding: "0.5vh 1vw",
    width: "200px",
    textTransform: "uppercase"
  },
  requestIconButton: {
    display: "inline",
    "@media only screen and (min-width: 600px)": {
      display: "none"
    }
  },
  requestIcon: {
    display: "none",
    "@media only screen and (min-width: 600px)": {
      display: "inline"
    }
  },
  rootDialog: {
    background: "rgba(18, 20, 30, 0.9)",
    color: "#FFF",
    maxWidth: "100%",
    "@media only screen and (max-width: 640px)": {
      minWidth: "100%"
    }
  }
});

const AccessTemplate = () => {
  const classes = useStyles();
  const history = useHistory();

  const { flowState } = useContext(UIContext);
  const { currentTrial } = useContext(SessionContext);

  const handleClose = () => {
    history.push("/");
  };

  const switchRender = () => {
    switch (flowState) {
      case 1:
        return <IntroAccess handleClose={handleClose} />;
      case 2:
        return <RequestAccess handleClose={handleClose} />;
      case 3:
        return <TrialAccess handleClose={handleClose} />;
      default:
        return;
    }
  };

  // TODO: This modal and the button to open it should not be mounted in the
  // same component. The button should only be available if the user has not
  // yet started a trial, but the /api-trial route should always be available.
  return (
    <React.Fragment>
      <Route
        path="/api-trial"
        component={() => (
          <Dialog
            open={true}
            onClose={handleClose}
            disableBackdropClick={true}
            disableEscapeKeyDown={true}
            aria-describedby="alert-dialog-description"
            style={{ textAlign: "center" }}
            classes={{ paper: classes.rootDialog }}
          >
            {flowState && switchRender()}
          </Dialog>
        )}
      />

      <Link to="/admin/api-access" style={{ textDecoration: "none" }}>
        <Button
          variant="contained"
          size="small"
          color="primary"
          className={classes.requestButton}
        >
          Get Your API Token
        </Button>
      </Link>
    </React.Fragment>
  );
};

export default AccessTemplate;
